import { funifierApi } from "./api";

export async function getContent(collection: string) {
  try {
    const { data } = await funifierApi.get(`database/${collection}`);
    if (Array.isArray(data)) {
      return data;
    }
    return [];
  } catch (err) {
    return [];
  }
}
